import { render, staticRenderFns } from "./LabelData.vue?vue&type=template&id=40beea2e"
import script from "./LabelData.vue?vue&type=script&lang=js"
export * from "./LabelData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports